import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQueryWithReAuth } from './baseQuery';

export const casApi = createApi({
  baseQuery: (...baseQueryArgs) => {
    const [args, api, extraOptions] = baseQueryArgs;
    return dynamicBaseQueryWithReAuth(args, api, extraOptions || { isCas: true });
  },
  endpoints: () => ({}),
  reducerPath: 'casApi',
});
